// Angular Modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

//Custom Components
import { TimerComponent } from './components/timer/timer.component';

// Providers
import { SettingsProvider } from './services/settings/settings';
import { SharedDataProvider } from './services/shared-data/shared-data';
import { ValidateProvider } from './services/validate/validate';
import { HelperProvider } from './services/helper/helper';
import { BasketakiRestProvider } from './services/basketaki-rest/basketaki-rest';
import { MblRestProvider } from './services/mbl-rest/mbl-rest';
import { LoadingProvider } from './services/loading/loading';
import { AlertProvider } from './services/alert/alert';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FilterHiddenPipe } from './pipes/filter-hidden.pipe';

@NgModule({
  declarations: [AppComponent, TimerComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot({
      backButtonText: 'Back',
      mode: 'ios',
    }),
    AppRoutingModule,
    // PipesModule,
    IonicStorageModule.forRoot(),
    Ng2SearchPipeModule,
  ],
  providers: [
    Geolocation,
    // InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    HelperProvider,
    SettingsProvider,
    SharedDataProvider,
    ValidateProvider,
    MblRestProvider,
    BasketakiRestProvider,
    LoadingProvider,
    AlertProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// Sentry.init({
//   dsn: 'https://b824cfba9a2d4a32968b7bbd7799dc9e@o373516.ingest.sentry.io/6069338',
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ['localhost', 'https://yourserver.io/api'],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });
// enableProdMode();
// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then((success) => console.log(`Bootstrap success`))
//   .catch((err) => console.error(err));
